'use client';

import { usePathname, useSearchParams } from 'next/navigation';

// TODO: this should take advantage of our common logic for checking same pathname / params
export function useCurrentURL(): string {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	let currentURL = `${pathname}`;
	if (!currentURL.endsWith('/')) {
		currentURL += '/';
	}

	const params = searchParams?.toString();
	if (params) {
		currentURL += `?${params}`;
	}

	return currentURL;
}
